<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() { 

  },
  methods: {
  },
}
</script>
<style>
html {
  height: 100%;
  /* overflow: hidden; */

}

body {
  height: 100%;
  background-color: #f4f4f4;
}

#app {
  height: 100%;
  /* overflow:auto; */
  font-family: Microsoft YaHei, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/bycx/App.vue